import * as React from 'react';
import { ParagraphText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { richTextElementsCss } from '@web-config-app/core-react-ui';

export interface DefaultLocaleTextPreviewProps {
  defaultLocaleData?: string;
}

export const DefaultLocaleTextPreview: React.FC<
  DefaultLocaleTextPreviewProps
> = ({ defaultLocaleData }) => {
  const { formatMessage } = useIntl();

  return (
    <ParagraphText
      css={{ marginBlockStart: '$quarter', ...richTextElementsCss }}
      emphasis={defaultLocaleData ? 'base' : 'subtle'}
    >
      {defaultLocaleData || formatMessage({ id: 'EMPTY_DEFAULT_LOCALE_DATA' })}
    </ParagraphText>
  );
};
